module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h1>Privacy policy</h1>\n<div class="content">\n  <a class="btn btn-default" href="' +
((__t = ( URL_PRIVACY_POLICY )) == null ? '' : __t) +
'" style="font-size: 1.2em;" target="_blank" rel="noopener noreferrer">\n    <img src="icon-file-pdf.svg" style="height: 1.2em; vertical-align: top; transform: translate(0, 0.1em);" />\n    PDF\n  </a>\n</div>\n';

}
return __p
}